import React from 'react';
import { twMerge } from 'tailwind-merge';
type SectionHeadingProps = {
  id?: string;
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  tone?: 'light' | 'dark';
  className?: string;
};
export function SectionHeading({
  id,
  eyebrow,
  title,
  subtitle,
  align = 'left',
  tone = 'light',
  className
}: SectionHeadingProps) {
  const dark = tone === 'dark';
  return <div className={twMerge(align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl', className)} data-id="element-406" data-mp="bk3mnhpoyr6r">
      {eyebrow && <p className={twMerge('mb-3 font-display text-xs font-extrabold uppercase tracking-[0.14em] sm:text-sm', dark ? 'text-teal-light' : 'text-teal-dark')} data-id="element-407" data-mp="gix3nk46t0bo">
          {eyebrow}
        </p>}
      <h2 id={id} className={twMerge('text-balance font-heading text-[1.95rem] font-extrabold leading-[1.1] tracking-[-0.01em] sm:text-4xl lg:text-[2.85rem]', dark ? 'text-white' : 'text-navy')} data-id="element-408" data-mp="uippb10uwqcs">
        {title}
      </h2>
      {subtitle && <p className={twMerge('mt-4 text-base leading-relaxed sm:text-lg', dark ? 'text-white/90' : 'text-navy-soft')} data-id="element-409" data-mp="1obe8umrt998a">
          {subtitle}
        </p>}
    </div>;
}